<template>
    <div class="flippable" :class="{'flippable--flipped': isFlipped}" @click="isFlipped = !isFlipped">
        <div class="flippable__inner">
            <div class="flippable__front">
                <slot name="front" />
            </div>
            <div class="flippable__back">
                <slot name="back" />
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
    import {ref} from 'vue';

    const isFlipped = ref(false);
</script>

<style lang="scss">
    .flippable {
        --flip-duration: 0.6s;
        perspective: 1000px;
        outline: none;

        &__inner {
            position: relative;
            transform-style: preserve-3d;
            transition: transform var(--flip-duration) ease-in-out;
            will-change: transform;
        }

        &__front,
        &__back {
            backface-visibility: hidden;
            -webkit-backface-visibility: hidden;
        }

        &__back {
            position: absolute;
            inset: 0;
            transform: rotate3d(0, 1, 0, 180deg);
        }

        &--flipped &__inner {
            transform: rotate3d(0, 1, 0, -180deg);
        }
    }
</style>
